"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const common_1 = require("@components/common");
const typography_1 = require("@components/typography");
const styled_components_1 = __importDefault(require("styled-components"));
const SectionWrap = (0, styled_components_1.default)(common_1.Flex).attrs({
    mb: "30px",
    direction: "column",
}) `
  .spread {
    grid-column: 1 / -1;
    justify-content: flex-start;
    gap: 24px;

    .checkbox-wrap {
      width: 100%;
    }
  }

  .spread {
    @media screen and (min-width: 600px) {
      display: grid;
      grid-template-columns: repeat(2, 2fr);
    }

    @media screen and (min-width: 1920px) {
      grid-template-columns: repeat(3, 324px);
    }
  }

  & > .exercises-wrap {
    @media screen and (min-width: 1200px) {
      display: grid;
      grid-template-columns: repeat(2, 2fr);
    }

    @media screen and (min-width: 1920px) {
      grid-template-columns: repeat(3, 324px);
    }
  }

  & > .framed > .framed[open].exercises {
    grid-column: span 4 / span 4;
  }
`;
const ExerciseSection = ({ title, children }) => {
    return (react_1.default.createElement(SectionWrap, null,
        react_1.default.createElement(common_1.Box, { m: "20px 0" },
            react_1.default.createElement(typography_1.H3, null, title)),
        children));
};
exports.default = ExerciseSection;
